/**
 * Hook para debug de autenticação
 * Usado para diagnosticar problemas de login em produção
 */

import { useEffect, useState } from 'react';
import { getAuthToken } from '@/utils/auth';

export function useAuthDebug() {
  const [cookies, setCookies] = useState<string>('');
  const [isDebugMode, setIsDebugMode] = useState(false);

  useEffect(() => {
    // Ativa modo debug se ?debug=auth na URL
    const params = new URLSearchParams(window.location.search);
    if (params.get('debug') === 'auth') {
      setIsDebugMode(true);
      console.log('🔍 Auth Debug Mode ATIVADO');
    }
  }, []);

  useEffect(() => {
    if (isDebugMode) {
      // Atualiza cookies a cada 1 segundo
      const interval = setInterval(() => {
        setCookies(document.cookie);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isDebugMode]);

  return {
    isDebugMode,
    cookies,
    debugInfo: {
      userAgent: navigator.userAgent,
      url: typeof window !== 'undefined' ? window.location.href : 'unknown',
      localStorage: typeof window !== 'undefined' ? {
        accessToken: !!getAuthToken(),
        user: !!localStorage.getItem('user'),
      } : null,
    },
  };
}
